import SelectInput from '@components/SelectInput'
import { styled } from '@mui/material'
import { useCallback } from 'react'
import { ExplorerSection, NavRoute } from 'types/explorer'

type NavigationSelectProps = {
  routes: NavRoute[]
  onSelect: (section: ExplorerSection) => void
  value: ExplorerSection
}

const NavigationSelectInput = styled(SelectInput)(() => ({
  input: {
    borderRadius: 2,
    '.MuiOutlinedInput-notchedOutline': {
      borderRadius: 2,
    },
  },
  itemText: {
    fontSize: '1rem',
  },
}))

function NavigationSelect({ routes, onSelect, value }: NavigationSelectProps) {
  const getCapitalizedName = (name: string) => {
    return `${name.charAt(0).toUpperCase()}${name.substring(1, name.length)}`
  }

  const selectNavHandler = useCallback(
    (explorerSection: string) => {
      onSelect(explorerSection as ExplorerSection)
    },
    [onSelect],
  )

  const items = routes.map((route) => ({
    name: getCapitalizedName(route.name),
    value: route.name,
  }))

  return (
    <NavigationSelectInput
      noEmptyValue
      noLabel
      initialValue={value}
      onChange={selectNavHandler}
      items={items}
    />
  )
}

export default NavigationSelect
